import React from "react";
import { Target, Binoculars } from "@phosphor-icons/react";

const AboutUs = () => {
    return (
        <section id="sobre-nosotros" className="bg-white py-20">
            <div className="container mx-auto px-4 max-w-5xl">

                <div className="text-center mb-14">
                    <h2 className="text-4xl font-bold text-ctex-blue mb-6 uppercase tracking-tighter italic">
                        ¿Quiénes Somos?
                    </h2>

                    <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto font-medium">
                        CTEX es una empresa especializada en soluciones técnicas de
                        <strong className="text-ctex-blue"> refrigeración, cocción y climatización</strong> para entornos
                        comerciales e industriales que requieren continuidad operativa.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {/* MISIÓN */}
                    <article className="bg-white p-8 rounded-3xl shadow-xl border-t-4 border-ctex-orange transition-transform hover:-translate-y-1 duration-300">
                        <h3 className="text-2xl font-black text-gray-900 flex items-center mb-4 uppercase tracking-tight italic">
                            <Target size={32} weight="duotone" className="text-ctex-orange mr-3" aria-hidden="true" />
                            Nuestra Misión
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                            Brindar soluciones técnicas confiables mediante mantenimiento,
                            instalación y diagnóstico profesional, asegurando la eficiencia de sus activos.
                        </p>
                    </article>

                    {/* VISIÓN */}
                    <article className="bg-white p-8 rounded-3xl shadow-xl border-t-4 border-ctex-orange transition-transform hover:-translate-y-1 duration-300">
                        <h3 className="text-2xl font-black text-gray-900 flex items-center mb-4 uppercase tracking-tight italic">
                            <Binoculars size={32} weight="duotone" className="text-ctex-orange mr-3" aria-hidden="true" />
                            Nuestra Visión
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                            Ser el referente técnico líder en soluciones térmicas comerciales e industriales del sureste mexicano, destacados por nuestra excelencia y tiempo de respuesta.
                        </p>
                    </article>
                </div>

            </div>
        </section>
    );
};

export default AboutUs;



